import { datePickerFormat, toDate } from "../../utils/dates";

export const getCopyAndReplaceItemByIndex = (index, array, defaultValue = null) => {
  const copy = [...array];
  copy[index] = defaultValue;

  return copy;
};

export const getSameFreeIndexInArrays = (array1, array2) => (
  array1.findIndex((item, index) => !array2[index] && !item)
);

export const onLastCalibrationChange = (value) => {
  let NextCalibration = toDate(value);
  NextCalibration.setFullYear(NextCalibration.getFullYear() + 1);

  return { NextCalibration };
}

export const checkLegacy = (legacyDevices, deviceType) => (
  legacyDevices.some((word) => deviceType.startsWith(word))
);

export const getFieldEditMode = (pageEditMode, widgetId, IsDeviceCalibrationDate) => (
  widgetId !== 'LastCalibration' ? pageEditMode : IsDeviceCalibrationDate === 'false'
);

export const getFormat = (widgetId, IsDeviceCalibrationDate) => {
  if (['NextCalibration', 'LastCalibration'].includes(widgetId)) {
    return datePickerFormat;
  };

  return undefined;
}



// WEBPACK FOOTER //
// src/components/dynamicTestDetails/utils.js